<template>
  <v-card>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      @submit.prevent="
        loading = true;
        userType === 'existing'
          ? createAdmin(existingUser)
          : createNewAdminUser();
      "
    >
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>New Admin</v-toolbar-title>
      </v-app-bar>
      <v-card-text class="pt-3">
        <v-container grid-list-lg class="pt-0">
          <v-radio-group v-model="userType" row>
            <v-radio
              color="primary"
              label="Exising User"
              value="existing"
            ></v-radio>
            <v-radio
              color="primary"
              label="Create New User"
              value="new"
            ></v-radio>
          </v-radio-group>
          <div v-if="userType === 'existing'">
            <v-autocomplete
              v-model="existingUser"
              :items="users"
              :loading="loadingUsers"
              hide-selected
              item-text="email"
              return-object
              label="User"
              dense
              placeholder="Start typing to find user"
              prepend-icon="person"
              :rules="[v => !!v || 'Select a user']"
              required
            />
          </div>
          <div v-else>
            <v-text-field
              v-model="newUser.email"
              label="Email*"
              :rules="[rules.required]"
              required
            />
            <v-text-field
              v-model="newUser.password"
              :append-icon="showPass1 ? 'visibility_off' : 'visibility'"
              :rules="[rules.required, rules.min]"
              :type="showPass1 ? 'text' : 'password'"
              label="Password*"
              hint="At least 8 characters"
              @click:append="showPass1 = !showPass1"
            ></v-text-field>
            <v-text-field
              v-model="newUser.confirm_password"
              :append-icon="showPass2 ? 'visibility_off' : 'visibility'"
              :rules="[rules.required, rules.passMatch]"
              :type="showPass2 ? 'text' : 'password'"
              label="Confirm Password*"
              @click:append="showPass2 = !showPass2"
            ></v-text-field>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn color="error" text @click="$emit('close')"> Cancel </v-btn>
        <v-btn
          color="success"
          :disabled="!valid"
          type="submit"
          :loading="loading"
        >
          Create Admin
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {
  usersCollection,
  adminsCollection,
  FieldValue,
  fbfunctions
} from '@/firebaseConfig';

const defaultData = {
  newUser: {
    email: '',
    password: '',
    confirm_password: null
  },
  existingUser: null,
  userType: 'existing',
  valid: true,
  showPass1: false,
  showPass2: false,
  loadingUsers: false,
  users: [],
  loading: false
};

export default {
  name: 'NewAdmin',
  data() {
    return {
      newUser: {
        email: '',
        password: '',
        confirm_password: null
      },
      existingUser: null,
      userType: 'existing',
      valid: true,
      showPass1: false,
      showPass2: false,
      loadingUsers: false,
      users: [],
      loading: false
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    },
    rules() {
      return {
        required: v => !!v || 'Required',
        min: v => v.length >= 8 || 'Min 8 characters',
        passMatch: v =>
          v === this.newUser.password || "The passwords you entered don't match"
      };
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    reset() {
      Object.assign(this.$data, defaultData);
    },
    getUsers() {
      this.$bind('users', usersCollection)
        .then(() => {
          this.loaded = true;
        })
        .catch(error => {
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error loading users: ${error}`
          });
        });
    },
    createNewAdminUser() {
      if (this.$refs.form.validate()) {
        let addUser = fbfunctions.httpsCallable('createUser');
        let email = this.newUser.email;
        let password = this.newUser.password;
        addUser({ email, password })
          .then(res => {
            this.createAdmin(res.data);
          })
          .catch(error => {
            this.$store.dispatch('createSnackbar', {
              color: 'error',
              text: `Error creating user: ${error}`
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    createAdmin(user) {
      let successRes = () => {
        this.$emit('close');
        this.$store.dispatch('createSnackbar', {
          color: 'success',
          text: `New admin created successfully`
        });
        this.reset();
      };
      let errorRes = error => {
        this.$store.dispatch('createSnackbar', {
          color: 'error',
          text: `Error adding admin: ${error}`
        });
      };
      let adminRef = adminsCollection.doc(user.id || user.uid);
      let info = {
        email: user.email,
        locations: [this.currentLocationId]
      };
      if (this.$refs.form.validate()) {
        adminRef.get().then(snapshot => {
          if (snapshot.exists) {
            adminRef.onSnapshot(doc => {
              doc.ref
                .update({
                  locations: FieldValue.arrayUnion(this.currentLocationId)
                })
                .then(successRes())
                .catch(error => errorRes(error))
                .finally(() => {
                  this.loading = false;
                });
            });
          } else {
            adminRef
              .set(info)
              .then(successRes())
              .catch(error => errorRes(error))
              .finally(() => {
                this.loading = false;
              });
          }
        });
      }
    }
  }
};
</script>
